import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {FormattedMessage, FormattedNumber} from "react-intl";
import {isRequiredSentToBell} from "../../globals/workOrderStatus";
import {requestBillingActivities, saveBillingSKUInfo} from "../../redux/billing/billingActions";
import {Divider, Typography, FormControlLabel, Checkbox} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {Table, TableBody, TableCell, TableHead, TableRow, TableFooter} from "@material-ui/core";
import {useWorkOrderStyles, Caption, Value} from "./workOrderDetails";
import SKURow from "./skuRow";
import WinterPremium from "./winterPremium";
import SKURowEdit from "./skuRowEdit";
import Button from "../common/button/button";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    "@media print": {
      whiteSpace: "normal",
    },
  },
  numberColumn: {
    width: 120,
  },
  skuColumn: {
    width: 200,
  },
  descriptionColumn: {
    width: 280,
  },
  deleteColumn: {
    width: 50,
  },
  errorMsg: {
    color: "red",
  },
  winterPremiumLabel: {
    color: "#0075FF",
    fontSize: 12,
  },
  winterPremiumLabelNormal: {
    color: "black",
    fontSize: 12,
  },
}));

export const WINTER_PERIOD_PREMIUM = "013477NM";

const EOL_PRODUCT_LIST = ["889326NM", "031595NM", "034065NM"];

const SKUList = (props) => {
  const dispatch = useDispatch();
  const woClasses = useWorkOrderStyles();
  const tableClasses = useStyles();
  const {woSkuList} = props;
  const login = useSelector(state => state.login);
  const billingActivities = useSelector((state) => state.billing.activities);
  const billingReasons = useSelector((state) => (state.reasons.partialReasons.has("BillingReason") ? state.reasons.partialReasons.get("BillingReason").filter((reason) => reason?.displayReason && reason?.FK_Status_Id === 10) : []));
  const [skuList, setSkuList] = useState([]);
  const [deletedSkuIds, setDeletedSkuIds] = useState([]);
  const [newRowCount, setNewRowCount] = useState(0);
  const [error, setError] = useState(false);
  const [activities, setActivities] = useState(billingActivities ? billingActivities : []);
  const [tempSkuRow, setTempSkuRow] = useState([]);
  const [showWinterPremiumCheckbox, setShowWinterPremiumCheckbox] = useState(false);
  const [winterPricingCheckboxStatus, setWinterPricingCheckboxStatus] = useState(false);
  const [enabledWinterPremium, setEnabledWinterPremium] = useState(false);
  const [originalEnableWinterPremium, setOriginalEnableWinterPremium] = useState(false);
  const [winterCost, setWinterCost] = useState(0.0);
  const [costTotal, setCostTotal] = useState(0);
  const [winterQuantity, setWinterQuantity] = useState(0.0);
  const [, refreshState] = useState({});
  const [enabledWinterPremiumObject, setEnabledWinterPremiumObject] = useState(null);
  const [winterPricedId, setWinterPricedId] = useState(null);
  const [checkboxEnable, setCheckboxEnable] = useState(false);
  const [originalCheckboxEnable, setOriginalCheckboxEnable] = useState(false);
  const [winterItems, setWinterItems] = useState(true);
  // fetch activities based on the contract number
  const contractNumber = props.workorderData?.contractNumber;
  const completedDate = props.workorderData?.completionDate;
  const workOrderNumber = props.workorderData?.workOrderNumber;
  const isEOL = props.workorderData?.reasonCodeId === 1;
  const [resetStatus, setResetStaus] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [updatedSKU, setUpdatedSKU] = useState({
    addtionalDetailValue: "",
    billingReasonValue: null,
    quantityValue: 0,
    productCodeValue: ""
  })
  useEffect(() => {
    if (contractNumber) dispatch(requestBillingActivities(contractNumber, completedDate));
  }, [contractNumber, completedDate]);

  useEffect(() => {
    billingActivities.map((item) => {
      if (process.env.REACT_APP_FEATURE_WINTERPRICE === "false") item.winterPricingEligibility = false;
    });
    if (isEOL && billingActivities) {
      setActivities(billingActivities || []);
    } else {
      setActivities(billingActivities ? billingActivities : []);
    }
    const validWinter = billingActivities.map((sku) => {
      if (sku.productCode == WINTER_PERIOD_PREMIUM) {
        setEnabledWinterPremiumObject(sku);
      }
      return;
    });
  }, [isEOL, billingActivities]);

  // rebuild the local mutable copy of the SKU list
  useEffect(() => {
    const skus = woSkuList.map((sku) => {
      if (!showWinterPremiumCheckbox) {
        var showWinterPremiumCheckboxValue = false;
        if (billingActivities.find((a) => a.productCode == sku.productCode)) {
          showWinterPremiumCheckboxValue = billingActivities.find((a) => a.productCode == sku.productCode).winterPricingEligibility;
        }
        if (showWinterPremiumCheckboxValue) {
          setShowWinterPremiumCheckbox(true);
        }
      }

      if (sku.productCode == WINTER_PERIOD_PREMIUM) {
        setWinterPricedId(sku.id);
        setCheckboxEnable(true);
        setOriginalCheckboxEnable(true);
        setEnabledWinterPremium(true);
        setOriginalEnableWinterPremium(true);
        setWinterPricingCheckboxStatus(true);
        setWinterQuantity(sku.quantity);
        setWinterCost(sku.cost);
      }

      const activity = activities.find((a) => {
        return a.productCode === sku.productCode;
      });
      let nonActivityPrice = "";
      if(sku) {
        nonActivityPrice = sku.cost / sku.quantity;
      }
      return {
        ...sku,
        price: !!nonActivityPrice ? nonActivityPrice : activity?.price,
        productDescription_en: activity && activity.productDescription_en ? activity.productDescription_en : sku.productDescription_en,
        productDescription_fr: activity && activity.productDescription_fr ? activity.productDescription_fr : sku.productDescription_fr,
        winterElligibleSKU: activity ? activity.winterPricingEligibility : "",
        isBillingReasonRequired: sku?.productCode === activity?.productCode && activity?.isBillingReasonRequired,
        billingReason: sku?.productCode === activity?.productCode && activity?.isBillingReasonRequired ? sku?.billingReasonCode?.id : ""
      };
    });
    if (skus.filter((item) => item.winterElligibleSKU == true).length == 1 && skus.find((item) => item.productCode == WINTER_PERIOD_PREMIUM)) {
      setWinterItems(true);
      setCheckboxEnable(true);
      setEnabledWinterPremium(true);
    }
    setCostTotal(skus.reduce((accumulator, row) => accumulator + row.quantity * row.price, 0));
    setSkuList(
      skus.filter((item) => {
        if (item.productCode != WINTER_PERIOD_PREMIUM) return item;
      }),
    );
    setError(skus.length === 0 && isRequiredSentToBell(props.workorderData?.status));
  }, [woSkuList, activities, resetStatus]);

  const addSKU = () => {
    setSkuList([
      ...skuList,
      {
        id: `new-${newRowCount}`,
        productCode: "",
        productDescription_en: "",
        productDescription_fr: "",
        cost: 0,
        quantity: 0,
        price: 0,
        unitOfMeasure: "",
        new: true,
        additionalDetails: "",
        billingReasonCode: null
      },
    ]);
    setNewRowCount(newRowCount + 1);
    setDisabledButton(true)
    setError(false);
  };

  const handleWinterPremium = (e) => {
    if (checkboxEnable != e.target.checked) setOriginalCheckboxEnable(checkboxEnable);
    setWinterItems(e.target.checked);
    setCheckboxEnable(e.target.checked);
    setWinterPricingCheckboxStatus(e.target.checked);
    setEnabledWinterPremium(e.target.checked);
    calculateWinterQuantity(tempSkuRow);
    refreshState({});
  };

  const calculateWinterQuantity = (tempSkuRows) => {
    let total = 0;
    let quantity = 0;
    skuList.map((sku) => {
      const activity = billingActivities.find((a) => {
        if (a.productCode === sku.productCode && a.productCode != WINTER_PERIOD_PREMIUM) {
          return a;
        }
      });
      if (enabledWinterPremiumObject && activity && activity.winterPricingEligibility) {
        const rowMatched = tempSkuRows && tempSkuRows.length > 0 ? tempSkuRows.find((a) => a.id == sku.id) : null;
        if (tempSkuRows && tempSkuRows.length > 0 && rowMatched) {
          quantity = quantity + Number(rowMatched.quantity * rowMatched.price);
        } else {
          quantity = quantity + Number(sku.id.toString().includes("new") ? sku.quantity * sku.price : sku.cost);
        }
      }
    });

    total = enabledWinterPremiumObject ? quantity * enabledWinterPremiumObject.price : null;
    setWinterQuantity(quantity);
    setWinterCost(total);
  };
  const removeSKU = (index) => {
    if (skuList.length === 1 && !isEOL) {
      setError(true);
      //return;
    }
    const deletedSku = skuList.splice(index, 1);
    if (!deletedSku[0].new) {
      deletedSkuIds.push({id: deletedSku[0].id});
    }
    setSkuList([...skuList]);
    var showWinterPremiumCheckboxValue = false;
    const skus = skuList.map((sku) => {
      if (!showWinterPremiumCheckboxValue && billingActivities.find((a) => a.productCode == sku.productCode)) {
        showWinterPremiumCheckboxValue = billingActivities.find((a) => a.productCode == sku.productCode).winterPricingEligibility;
      }
    });
    if (showWinterPremiumCheckboxValue) {
      setShowWinterPremiumCheckbox(true);
    } else {
      setShowWinterPremiumCheckbox(false);
      setWinterItems(false);
      setCheckboxEnable(false);
      setOriginalCheckboxEnable(false);
      setEnabledWinterPremium(false);
    }
    calculateWinterQuantity();
  };

  const cancel = () => {
    setCheckboxEnable(originalCheckboxEnable);
    setEnabledWinterPremium(originalEnableWinterPremium);
    setTempSkuRow([]);

    const skus = woSkuList?.map((sku) => {
      const activity = activities.find((a) => a.productCode === sku.productCode);
      var resetSku = Object.assign({}, sku);
      resetSku.price = activity ? activity.price : sku.cost;
      resetSku.productDescription_en = activity?.productDescription_en ? activity?.productDescription_en : sku?.productDescription_en;
      resetSku.productDescription_fr = activity?.productDescription_fr ? activity?.productDescription_fr : sku?.productDescription_fr;
      resetSku.winterElligibleSKU = activity?.winterPricingEligibility;
      return resetSku;
    });

    setSkuList(skus);
    setDeletedSkuIds([]);
    setError(skus.length === 0);
    calculateWinterQuantity();
    setResetStaus(!resetStatus);
    props.onClose();
  };

  const onSave = () => {
    setTempSkuRow([]);
    if (skuList.length === 0 && !isEOL) {
      setError(true);
    }

    for (var i = 0; i < skuList.length; i++) {
      if(skuList[i]?.isBillingReasonRequired && (!skuList[i]?.billingReason || !skuList[i]?.additionalDetails)){
        return;
      }
      if (skuList[i].quantity === 0 || isNaN(parseFloat(skuList[i].quantity)) || !skuList[i].productCode) return;
      if (!skuList[i].price) {
        const activity = activities.find((a) => a.productCode === skuList[i].productCode);
        skuList[i].price = activity ? activity.price : 0;
      }
    }

    let skuWithWinterPriceEntry = enabledWinterPremiumObject
      ? skuList.filter((item) => item.productCode != enabledWinterPremiumObject.productCode)
      : [...skuList];
    if (winterItems && enabledWinterPremium && enabledWinterPremiumObject && skuList.find((item) => item.winterElligibleSKU)) {
      skuWithWinterPriceEntry = [
        ...skuList,
        {
          id: winterPricedId ? winterPricedId : `new-${newRowCount}`,
          dirty: true,
          productCode: enabledWinterPremiumObject.productCode,
          productDescription_en: enabledWinterPremiumObject.productDescription_en,
          productDescription_fr: enabledWinterPremiumObject.productDescription_fr,
          cost: winterCost,
          quantity: winterQuantity,
          price: enabledWinterPremiumObject.price,
          unitOfMeasure: "$",
          new: winterPricedId ? false : true,
        },
      ];
    }
    if (!winterPricingCheckboxStatus && winterPricedId) deletedSkuIds.push({id: winterPricedId});
    if (!skuList.find((item) => item.winterElligibleSKU) && winterPricedId) deletedSkuIds.push({id: winterPricedId});
    if (!skuList.find((item) => item.winterElligibleSKU)) {
      setWinterItems(false);
      setCheckboxEnable(false);
      setOriginalCheckboxEnable(false);
      setEnabledWinterPremium(false);
    }
    var billingSKUInfo = {
      taskId: props.workorderData?.taskId,
      contractNumber: contractNumber,
      skuList: skuWithWinterPriceEntry
        .filter((sku) => sku.dirty)
        .map((sku) => {
          return {
            skuId: !sku.new ? sku.id : null,
            billingActivityCode: sku.productCode,
            billingActivity_en: sku.productDescription_en,
            billingActivity_fr: sku.productDescription_fr,
            quantity: sku.quantity ? sku.quantity : 0,
            unitOfMeasure: sku.unitOfMeasure,
            additionalDetails: sku.additionalDetails ? sku.additionalDetails : null,
            billingReasonCode: sku?.billingReason ? sku?.billingReason : null,
            winterPriceCost: sku.productCode == WINTER_PERIOD_PREMIUM ? Number(sku.cost).toFixed(2) : sku.price * sku.quantity,
          };
        }),
      deletedSKUs: deletedSkuIds,
    };
    // send the update and refresh the work order
    dispatch(saveBillingSKUInfo(billingSKUInfo, workOrderNumber, props.workorderData?.completionDate, true));

    // clear list of deleted skus
    setWinterPricedId(winterPricedId && deletedSkuIds.find((a) => a.id == winterPricedId) ? null : winterPricedId);
    setDeletedSkuIds([]);
    setEnabledWinterPremium(winterPricingCheckboxStatus);
    // toggle edit mode
    props.onClose();

    // Clear error
    setError(false);
  };

  const onQuantityChange = (row) => {
    //var isEligible = false;
    if (billingActivities.find((a) => a.productCode === row.productCode && a.winterPricingEligibility)) {
      // isEligible = true;
      if (tempSkuRow.length == 0 || !tempSkuRow.find((a) => a.id == row.id)) {
        tempSkuRow.push(row);
      } else {
        tempSkuRow.map((item) => {
          if (item.id == row.id) {
            item.quantity = row.quantity;
          }
        });
      }
      calculateWinterQuantity(tempSkuRow);
    }
    setCostTotal(skuList.reduce((accumulator, row) => accumulator + row.quantity * row.price, 0));
    var showWinterPremiumCheckboxValue = false;
    skuList.map((sku) => {
      if (!showWinterPremiumCheckboxValue && billingActivities.find((a) => a.productCode == sku.productCode)) {
        showWinterPremiumCheckboxValue = billingActivities.find((a) => a.productCode == sku.productCode).winterPricingEligibility;
      }
    });
    if (showWinterPremiumCheckboxValue) {
      setShowWinterPremiumCheckbox(true);
    } else {
      setShowWinterPremiumCheckbox(false);
    }
    if (!showWinterPremiumCheckboxValue) {
      setWinterItems(false);
      setCheckboxEnable(false);
      setOriginalCheckboxEnable(false);
      setEnabledWinterPremium(false);
    }
  };
  

  useEffect(()=>{
    const skuListData = skuList?.length > 0 ? skuList?.filter(item => (item.isBillingReasonRequired && (!item?.billingReasonCode || !item?.additionalDetails) || !item?.quantity || !item?.productCode)) : []
    setDisabledButton(skuListData?.length)
  },[updatedSKU])

  return (
    <Table className={tableClasses.table} aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell align="left" className={tableClasses.skuColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.sku-number-col-header" defaultMessage="SKU #" description="Admin work order sku list number column header" />
            </Caption>
          </TableCell>
          <TableCell align="left" className={tableClasses.descriptionColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.sku-name-col-header" defaultMessage="SKU name" description="Admin work order sku list name column header" />
            </Caption>
          </TableCell>
          <TableCell align="left" className={tableClasses.descriptionColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.billing-reason-col-header" defaultMessage="Billing reason" description="Admin work order sku list name column header" />
            </Caption>
          </TableCell>
          <TableCell align="left">
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.additional-details-col-header" defaultMessage="Additional details" description="Admin work order sku list additional details column header" />
            </Caption>
          </TableCell>
          <TableCell align="right" className={tableClasses.numberColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.quantity-col-header" defaultMessage="Quantity" description="Admin work order sku list quantity column header" />
            </Caption>
          </TableCell>
          <TableCell align="right" className={tableClasses.numberColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.units-col-header" defaultMessage="Unit" description="Admin work order sku list unit column header" />
            </Caption>
          </TableCell>
          <TableCell align="right" className={tableClasses.numberColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.unit-price-col-header" defaultMessage="Unit price" description="Admin work order sku list unit price column header" />
            </Caption>
          </TableCell>
          <TableCell align="right" className={tableClasses.numberColumn}>
            <Caption>
              <FormattedMessage id="admin.work-order-details.sku-list.sku-total-col-header" defaultMessage="SKU total" description="Admin work order sku list SKU total column header" />
            </Caption>
          </TableCell>
          <TableCell align="center" className={tableClasses.deleteColumn}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {error && !isEOL && (
          <TableRow>
            <TableCell colSpan="8" className={tableClasses.errorMsg}>
              <FormattedMessage id="admin.work-order-details.sku-list.skus-required-error-msg" defaultMessage="At least 1 SKU is mandatory for billing submission" description="Admin work order sku list SKUs mandatory error message" />
            </TableCell>
          </TableRow>
        )}

        {skuList
          .filter((item) => item.productCode != WINTER_PERIOD_PREMIUM)
          .map((row, i) => {
            return props.edit ? (
              <SKURowEdit
                key={row.id}
                row={row}
                winterCost={winterCost}
                winterQuantity={winterQuantity}
                checkbox={enabledWinterPremium && checkboxEnable}
                enabledWinterPremiumObject={enabledWinterPremiumObject}
                removeSKU={() => removeSKU(i)}
                activities={activities}
                onQuantityChange={onQuantityChange}
                billingReasons={billingReasons}
                setDisabledButton={setDisabledButton}
                skuList={skuList}
                updatedSKU={updatedSKU}
                setUpdatedSKU={setUpdatedSKU}
              />
            ) : (
              <SKURow key={row.id} row={row} winterPremium={enabledWinterPremium && checkboxEnable} />
            );
          })}
        {winterItems && enabledWinterPremium && enabledWinterPremiumObject && process.env.REACT_APP_FEATURE_WINTERPRICE === "true" && <WinterPremium row={enabledWinterPremiumObject} winterQuantity={winterQuantity} winterCost={winterCost} checkbox={enabledWinterPremium} />}
      </TableBody>
      <TableFooter>
        {props.edit && (
          <>
            <TableRow>
              <TableCell align="left" colSpan="4">
                <Button secondary onClick={() => addSKU()}>
                  <FormattedMessage id="admin.work-order-details.sku-list.add-sku-button-caption" defaultMessage="Add SKU" description="Admin work order sku list Add SKU button caption" />
                </Button>
              </TableCell>
              <TableCell align="right" colSpan="4">
                {process.env.REACT_APP_FEATURE_WINTERPRICE === "true" && showWinterPremiumCheckbox && (
                  <FormControlLabel
                    control={<Checkbox checked={checkboxEnable} disableRipple color="primary" onChange={handleWinterPremium} />}
                    label={<FormattedMessage id="admin.work-order-details.sku-list.apply-winter-premium" defaultMessage="Apply Winter Premium" description="Admin work order sku list Apply Winter Premium checkbox label" />}
                    classes={{
                      label: enabledWinterPremium && winterItems ? tableClasses.winterPremiumLabel : tableClasses.winterPremiumLabelNormal,
                    }}
                  />
                )}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="right" colSpan="8">
                <Divider />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" colSpan="6">
                <Button tertiary onClick={() => (cancel(), dispatch(props?.disableBellToSendButton(false)))}>
                  <FormattedMessage id="admin.work-order-details.sku-list.cancel-sku-edit-button-caption" defaultMessage="Cancel" description="Admin work order sku list cancel SKU edit button caption" />
                </Button>
              </TableCell>
              <TableCell align="right" colSpan="2">
                <Button secondary onClick={() => onSave()} disabled={disabledButton}>
                  <FormattedMessage id="admin.work-order-details.sku-list.save-sku-edit-button-caption" defaultMessage="Save changes" description="Admin work order sku list save SKU edit button caption" />
                </Button>
              </TableCell>
            </TableRow>
          </>
        )}
        <TableRow
          style={{
            height: 56,
          }}>
          <TableCell align="left" colSpan="7">
            <Typography className={woClasses.workOrderStatus}>
              <FormattedMessage id="admin.work-order-details.sku-list.wo-total-footer" defaultMessage="Work order total" description="Admin work order sku list WO total footer" />
            </Typography>
          </TableCell>
          <TableCell align="right" colSpan="1">
            <Value>
              <FormattedNumber value={costTotal} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
            </Value>
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
};

export default SKUList;
